import React, { useState, useEffect, useRef } from "react";
import './Header.css';
import { MdAccountCircle, MdFavorite, MdShoppingCart } from "react-icons/md";
import Loginform from "./Loginform";
import { toast } from "react-toastify";
import Viewcartitem from "../../Screens/Viewcartitem";
import { useSelector } from "react-redux";

const SocialMedia2 = ({ getCooki }) => {
    const [toggleLogin, setToggleLogin] = useState(false);
    const cartItems = useSelector(state => state.Reducer)
    const [opencart, setOpencart] = useState(false);
    const lengthItem = cartItems.length

    // Refs for detecting clicks outside
    const loginRef = useRef(null);
    const cartRef = useRef(null);

    // Close the login container or cart container on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Close login container if clicked outside
            if (loginRef.current && !loginRef.current.contains(event.target)) {
                setToggleLogin(false);
            }

            // Close cart container if clicked outside
            if (cartRef.current && !cartRef.current.contains(event.target)) {
                setOpencart(false);
            }
        };

        // Attach the event listener
        document.addEventListener("mousedown", handleClickOutside);

        // Cleanup the event listener on unmount
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
            <div className="social-media2">
                {/* Login Section */}
                <div className="mobile_icons" ref={loginRef}>
                    <MdAccountCircle
                        className="my-account"
                        onClick={() => setToggleLogin(!toggleLogin)}
                    />
                    <span style={{ position: "relative" }}>
                        <span
                            className="login-container"
                            style={{ display: toggleLogin ? "flex" : "none" }}
                        >
                            <Loginform setToggleLogin={setToggleLogin} />
                        </span>
                    </span>
                </div>

                {/* Favorite Section */}
                <div className="mobile_icons">
                    <span className="my-favorite">
                        <MdFavorite className="your-favorite" />
                        <span className="batch1">0</span>
                    </span>
                </div>

                {/* Cart Section */}
                <div className="mobile_icons" ref={cartRef}>
                    <span className="my-cart">
                        <MdShoppingCart
                            className="your-cart"
                            onClick={() => setOpencart(!opencart)}
                        />
                        <span className="batch2">{lengthItem}</span>
                    </span>
                    <span style={{ position: "relative" }}>
                        <span
                            className="viewcart_container"
                            style={{ display: opencart ? "flex" : "none" }}
                        >
                            <Viewcartitem />
                        </span>
                    </span>
                </div>
            </div>
        </>
    );
};

export default SocialMedia2;
